import { Users, Plane, Calendar, DollarSign, CheckCircle2, AlertCircle, MessageSquare, FileText, Clock, Building2, Circle, Briefcase, Heart, Stethoscope, UserPlus } from 'lucide-react';

export const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Color palette for dynamic stages
export const STAGE_COLORS = [
  { color: 'bg-blue-500', lightColor: 'bg-blue-50 border-blue-200', textColor: 'text-blue-700' },
  { color: 'bg-purple-500', lightColor: 'bg-purple-50 border-purple-200', textColor: 'text-purple-700' },
  { color: 'bg-amber-500', lightColor: 'bg-amber-50 border-amber-200', textColor: 'text-amber-700' },
  { color: 'bg-cyan-500', lightColor: 'bg-cyan-50 border-cyan-200', textColor: 'text-cyan-700' },
  { color: 'bg-indigo-500', lightColor: 'bg-indigo-50 border-indigo-200', textColor: 'text-indigo-700' },
  { color: 'bg-orange-500', lightColor: 'bg-orange-50 border-orange-200', textColor: 'text-orange-700' },
  { color: 'bg-pink-500', lightColor: 'bg-pink-50 border-pink-200', textColor: 'text-pink-700' },
  { color: 'bg-teal-500', lightColor: 'bg-teal-50 border-teal-200', textColor: 'text-teal-700' },
  { color: 'bg-sky-500', lightColor: 'bg-sky-50 border-sky-200', textColor: 'text-sky-700' },
  { color: 'bg-emerald-500', lightColor: 'bg-emerald-50 border-emerald-200', textColor: 'text-emerald-700' },
  { color: 'bg-rose-500', lightColor: 'bg-rose-50 border-rose-200', textColor: 'text-rose-700' },
  { color: 'bg-violet-500', lightColor: 'bg-violet-50 border-violet-200', textColor: 'text-violet-700' },
];

// Stage icons mapping - includes actual Zoho Bigin stage names
export const STAGE_ICONS = {
  // Pre Arrival and Engagement stages
  'Inquiry': MessageSquare,
  'Requirements Assesment': FileText,
  'Medical Assesment': Stethoscope,
  'Hospital Selection': Building2,
  'Hospital and Patient Approval': CheckCircle2,
  'Visa and Documents': FileText,
  'Travel and Logistics': Plane,
  'Pre Arrival Preparation': Calendar,
  'Completed': CheckCircle2,
  'Cancelled': AlertCircle,
  // Sales Pipeline stages
  'Qualification': FileText,
  'Needs Analysis': Users,
  'Proposal/Price Quote': DollarSign,
  'Negotiation/Review': MessageSquare,
  'Closed Won': CheckCircle2,
  'Closed Lost': AlertCircle,
  // Customer Onboarding stages
  'Patient Query': MessageSquare,
  'Gather Requirements': FileText,
  'Patient Onboarding': UserPlus,
  'Patient Quotation Sent': DollarSign,
  'Patient Approved': CheckCircle2,
  'Patient Visa and Documentation Begin': FileText,
  'Visa And Travel Arrangements': Plane,
  'Hospital Approval': Building2,
  'Dates Finalised / Treatment Scheduled': Calendar,
  'Arrival - Departure': Plane,
  // Patient Management stages
  'Appointment Requested': Calendar,
  'Consultation Scheduled': Calendar,
  'Consultation': Users,
  'Diagnosis': FileText,
  'Treatment Plan': FileText,
  'Treatment Started': Clock,
  'Under Treatment': Heart,
  'Post-Treatment Follow-up': Users,
  'Treatment Completed': CheckCircle2,
  // Patient Referral Management
  'New Referral': UserPlus,
  'Accepted': CheckCircle2,
  'Scheduled': Calendar,
  // Default
  'default': Circle
};

// Pipeline slug to name mapping
export const PIPELINE_SLUG_MAP = {
  'sales': 'Sales Pipeline',
  'customer-onboarding': 'Customer Onboarding',
  'pre-arrival': 'Pre Arrival and Engagement',
  'patient-management': 'Patient Management System',
  'patient-referral': 'Patient Referral Management'
};

// Pipeline icons
export const PIPELINE_ICONS = {
  'Sales Pipeline': Briefcase,
  'Customer Onboarding': UserPlus,
  'Pre Arrival and Engagement': Plane,
  'Patient Management System': Heart,
  'Patient Referral Management': Users
};

export const CLOSED_STAGES = [
  { id: 'Completed', label: 'Completed', color: 'bg-green-500', lightColor: 'bg-green-50 border-green-200', textColor: 'text-green-700', icon: CheckCircle2 },
  { id: 'Cancelled', label: 'Cancelled', color: 'bg-red-500', lightColor: 'bg-red-50 border-red-200', textColor: 'text-red-700', icon: AlertCircle },
  { id: 'Closed Won', label: 'Won', color: 'bg-green-500', lightColor: 'bg-green-50 border-green-200', textColor: 'text-green-700', icon: CheckCircle2 },
  { id: 'Closed Lost', label: 'Lost', color: 'bg-red-500', lightColor: 'bg-red-50 border-red-200', textColor: 'text-red-700', icon: AlertCircle },
];
